module.exports = __webpack_public_path__ + "img/BF.c687a881.svg";